import React from 'react'

import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import type { BasicWidgetProps } from '../../types'
import { useFavoriteStatsQuery, CardType } from '@edge/spark/io-dashboards'

const Favorites = ({ widgetId, handleConfig, readonly }: BasicWidgetProps): React.ReactElement => {
    const { data, loading } = useFavoriteStatsQuery()

    return (
        <SingleNumberWidget
            cardType={CardType.CUSTOM}
            cardHeaderText="My Favorites"
            action={{
                text: 'View Accounts',
                link: '/favorites',
            }}
            loading={loading}
            number={data?.auction?.search?.accountCount}
            text="Accounts Favorited"
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default Favorites
